import styled, { css } from 'styled-components';
import { ReactComponent as Selected } from 'styles/icons/option-selected.svg';
import { ReactComponent as UnSelected } from 'styles/icons/option-unselected.svg';
import { color, typography } from 'styles/settings';
import { normalize, withModifiers } from 'utils/styles';

const iconCss = css`
  height: ${normalize('18px')};
  width: ${normalize('18px')};
  margin-right: ${normalize('10px')};
  color: #666666;
  ${withModifiers('$invalid')`
    color: ${color.ui.danger};
  `}
`;

export const Container = styled.div`
  ${withModifiers('inGroup')`
    margin-right: 10px;
    margin-bottom: 10px;
  `};

  ${withModifiers('withForm')`
    margin-bottom: ${typography.size.md};
  `};
`;

export const LayoutContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  cursor: pointer;
`;

export const SelectedIcon = styled(Selected)`
  ${iconCss};
  background-color: ${color.neutral.plainBlack};
`;

export const UnSelectedIcon = styled(UnSelected)`
  ${iconCss};
`;
